import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from '../../containers/constants';

export const options = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.ENTITY_SEARCH_REQUEST,
      actionTypes.ENTITY_SEARCH_FAILURE,
      actionTypes.RESET_OPTIONS,
    )]: () => [],
    [actionTypes.ENTITY_SEARCH_SUCCESS]: (state, { payload }) => payload.items,
    [actionTypes.ENTITY_SEARCH_ALL_SUCCESS]: (state, { payload }) => payload.items,
  },
  [],
);

export const totalCount = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.ENTITY_SEARCH_REQUEST,
      actionTypes.ENTITY_SEARCH_FAILURE,
      actionTypes.RESET_OPTIONS,
    )]: () => 0,
    [actionTypes.ENTITY_SEARCH_SUCCESS]: (state, { payload }) => payload.totalCount,
  },
  0,
);

export default combineReducers({
  options,
  totalCount,
});
